/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterAggregatorProviderMap
 */
export interface GlobalFilterAggregatorProviderMap {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterAggregatorProviderMap
     */
    providerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterAggregatorProviderMap
     */
    aggregatorProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterAggregatorProviderMap
     */
    name?: string | null;
}

export function GlobalFilterAggregatorProviderMapFromJSON(json: any): GlobalFilterAggregatorProviderMap {
    return GlobalFilterAggregatorProviderMapFromJSONTyped(json, false);
}

export function GlobalFilterAggregatorProviderMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterAggregatorProviderMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
        'aggregatorProviderId': !exists(json, 'aggregatorProviderId') ? undefined : json['aggregatorProviderId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function GlobalFilterAggregatorProviderMapToJSON(value?: GlobalFilterAggregatorProviderMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerId': value.providerId,
        'aggregatorProviderId': value.aggregatorProviderId,
        'name': value.name,
    };
}


